<div>
  <div class="flex-row header-container">
    <div class="flex-row header-action">
      <div class="table-header-action flex-row">
        <app-cts-gantry-filter-dropdown></app-cts-gantry-filter-dropdown>
        <sh-input-text
          class="search-input-container"
          id="log-table-input-search"
          #searchInput
          (value-changed)="filterLogService.onInputChange(searchInput.value)"
          label="{{ 'cts.gantry.search' | translate }}"
        >
          <sh-icon slot="icon" icon="search" size="s" button></sh-icon>
        </sh-input-text>
      </div>
    </div>

    <div class="flex-row header-action">
      <a [routerLink]="['../logs', ctsEvent?.eventSource]" target="_blank">
        <sh-icon icon="arrow" size="m" button></sh-icon>
      </a>
      <sh-button
        id="log-table-cancel-icon-btn"
        (click)="onCancelClick()"
        (keydown.enter)="onCancelClick()"
        color="tertiary"
        size="max-content"
        label="{{ 'cts.gantry.closeLogs' | translate }}"
      ></sh-button>
    </div>
  </div>

  <div class="log-table">
    <api-call-gate [apiCall]="eventLogs">
      <ng-template #lastSuccessfulData>
        <sh-table multiselect (scroll-end)="pagination.onScrollEnd()">
          <sh-table-row slot="header">
            <sh-table-head min-width="48px" unsortable>
              <div class="icon-status">
                <sh-icon
                  icon="information"
                  size="s"
                  color="rgb(var(--ui-5))"
                ></sh-icon>
              </div>
            </sh-table-head>
            <sh-table-head
              id="log-table-header-timestamp"
              min-width="130px"
              columns="7"
              (toggle)="
                filterLogService.onToggleSort(
                  'timestamp',
                  $event.target.hasAttribute('sort-descending')
                )
              "
            >
              {{ 'cts.gantry.table.dateTime' | translate }}
            </sh-table-head>
            <sh-table-head
              id="log-table-header-domainId"
              min-width="125px"
              (toggle)="
                filterLogService.onToggleSort(
                  'domainId',
                  $event.target.hasAttribute('sort-descending')
                )
              "
            >
              {{ 'cts.gantry.table.domainId' | translate }}
            </sh-table-head>
            <sh-table-head
              id="log-table-header-message"
              columns="18"
              min-width="345px"
              (toggle)="
                filterLogService.onToggleSort(
                  'message',
                  $event.target.hasAttribute('sort-descending')
                )
              "
            >
              {{ 'cts.gantry.table.message' | translate }}
            </sh-table-head>
          </sh-table-row>
          @if (filteredLogs?.length > 0) {
            @for (log of filteredLogs; track log.domainId + $index) {
              <sh-table-row [class.row--error]="log.severity === STATUS_ERROR">
                <sh-table-cell min-width="48px">
                  <div class="icon-status">
                    <sh-icon
                      icon="{{ log.severity.toLocaleLowerCase() }}"
                      size="s"
                    ></sh-icon>
                  </div>
                </sh-table-cell>
                <sh-table-cell min-width="130px" columns="7">
                  {{
                    log.timestamp | ctsGantryTimezone: log.timestampOffset / 60
                  }}
                </sh-table-cell>
                <sh-table-cell min-width="125px">
                  {{ log.domainId }}
                </sh-table-cell>
                <sh-table-cell columns="18" min-width="345px">
                  {{ log.message }}
                </sh-table-cell>
              </sh-table-row>
            }
          } @else {
            <app-cts-gantry-log-empty-state
              id="cts-gantry-log-table-empty-state"
              [onlyErrorsMsg]="filterLogService.filter.errors"
            ></app-cts-gantry-log-empty-state>
          }
        </sh-table>
      </ng-template>
    </api-call-gate>
  </div>
</div>
